<template>
  <div>
    <div
      v-for="(clubInfo, clubInfoIndex) in clubInfoList"
      :key="`info-about-${clubInfoIndex}`"
      :class="{ 'mt-8': clubInfoIndex !== 0 }"
    >
      <div class="text-h6 text--text mb-2">
        {{ clubInfo.title }}
      </div>

      <component
        :is="clubInfo.isOrderedListElement ? 'ol' : 'ul'"
        v-if="useListElement"
      >
        <!-- eslint-disable vue/no-v-html -->
        <li
          v-for="(sentence, sentenceIndex) in clubInfo.sentences"
          :key="sentenceIndex"
          class="text-body-1 text--text mb-2"
          v-html="sentence"
        />
        <!-- eslint-enable vue/no-v-html -->
      </component>
      <template v-else>
        <div class="text-body-1 text--text">
          {{ clubInfo.sentences.join(' ') }}
        </div>
      </template>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ClubInfoModalContent',
  props: {
    clubInfoList: {
      type: Array,
      default: () => [
        {
          title: '',
          sentences: [],
        },
      ],
    },
    useListElement: {
      type: Boolean,
      default: false,
    },
  },
}
</script>
